import { artBoardActions } from '@store/reducers/artboard'
import type React from 'react'
import { useRef } from 'react'
import { useDispatch } from 'react-redux'

import { stopPropagationPreventDefaultHandler } from '@/helpers'
import { useArtboardMode } from '@/hooks'

type FilesCb = (data: DataTransfer) => void

const isFileDragged = ({ types }: DataTransfer) => types.includes('Files')

export const useFilesDrag = (onFilesDropped: FilesCb, disabled: boolean) => {
  const dispatch = useDispatch()

  const { dropzone: isDropMode } = useArtboardMode()

  const setDragActive = () => {
    if (disabled) {
      return
    }

    dispatch(artBoardActions.changeMode('dropzone'))
  }

  const unsetDragActive = () => {
    if (disabled) {
      return
    }

    dispatch(artBoardActions.changeMode('edit'))
  }

  const childEnterCount = useRef(0)

  const onEnter = (e: React.DragEvent) => {
    if (!isFileDragged(e.dataTransfer)) {
      return
    }

    stopPropagationPreventDefaultHandler(e)

    if (childEnterCount.current === 0) {
      setDragActive()
    }

    childEnterCount.current += 1
  }
  const onLeave = (e: React.DragEvent) => {
    if (!isFileDragged(e.dataTransfer)) {
      return
    }

    stopPropagationPreventDefaultHandler(e)

    childEnterCount.current -= 1

    if (childEnterCount.current === 0) {
      unsetDragActive()
    }
  }

  const onDrop = async (e: React.DragEvent) => {
    if (!isDropMode) {
      return
    }
    stopPropagationPreventDefaultHandler(e)

    unsetDragActive()
    childEnterCount.current = 0
    onFilesDropped(e.dataTransfer)
  }

  const onOver = (e: React.DragEvent) => {
    stopPropagationPreventDefaultHandler(e)
  }

  return { onDrop, onLeave, active: isDropMode, onEnter, onOver }
}
